/** Una sola llamada a google.accounts.id.initialize() por Client ID (evita GSI_LOGGER). */

let activeClientId = null;

const handlers = {
  onSuccess: null,
  onError: null,
};

function handleCredentialResponse(credentialResponse) {
  if (!credentialResponse?.credential) {
    handlers.onError?.();
    return;
  }
  handlers.onSuccess?.({
    credential: credentialResponse.credential,
    clientId: credentialResponse.client_id || credentialResponse.clientId || activeClientId,
    select_by: credentialResponse.select_by,
  });
}

export function ensureGoogleIdentityInitialized(clientId) {
  const id = String(clientId || '').trim();
  if (!id || typeof window === 'undefined' || !window.google?.accounts?.id) {
    return false;
  }
  if (activeClientId === id) {
    return true;
  }
  window.google.accounts.id.initialize({
    client_id: id,
    callback: handleCredentialResponse,
    use_fedcm_for_prompt: false,
  });
  activeClientId = id;
  return true;
}

export function setGoogleSignInHandlers({ onSuccess, onError } = {}) {
  handlers.onSuccess = onSuccess;
  handlers.onError = onError;
}

export function renderGoogleSignInButton(container, options) {
  if (!container || !window.google?.accounts?.id) return;
  container.replaceChildren();
  window.google.accounts.id.renderButton(container, options);
}
